import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import MenuItem, { MenuItemProps } from "@mui/material/MenuItem";
import Typography from "@mui/material/Typography";
import { ReactNode } from "react";

interface ToolbarIconMenuItemProps extends MenuItemProps {
    icon: ReactNode;
    label: string;
    shortcut?: string;
}

export function IconMenuItem({ icon, label, shortcut, ...menuItemProps }: ToolbarIconMenuItemProps) {
    return (
        <MenuItem {...menuItemProps}>
            <ListItemIcon>{icon}</ListItemIcon>
            <ListItemText sx={{ px: 1 }}>{label}</ListItemText>
            {shortcut && (
                <Typography variant="body2" sx={{ color: 'text.secondary' }} pl={3}>
                    {shortcut}
                </Typography>
            )}
        </MenuItem>
    );
}

export default IconMenuItem;